import { COINS_SVC_INIT_LOADING, COINS_SVC_INIT_SUCCESS, COINS_SVC_INIT_FAIL,
  COINS_SVC_SAVE_LOADING, COINS_SVC_SAVE_SUCCESS, COINS_SVC_SAVE_FAIL } from '@/store/types'

export const coinsSvcFee = {
  [COINS_SVC_INIT_LOADING](state) {
    state.coinsSvcFeeSettings.init = 0
    state.coinsSvcFeeSettings.initErr = []
    state.coinsSvcFeeSettings.menu = {}
  },
  [COINS_SVC_INIT_SUCCESS](state, data) {
    state.coinsSvcFeeSettings.init = 1
    state.coinsSvcFeeSettings.initErr = []
    state.coinsSvcFeeSettings.menu = data.menu
  },
  [COINS_SVC_INIT_FAIL](state, error) {
    state.coinsSvcFeeSettings.init = 2
    state.coinsSvcFeeSettings.initErr = error
    state.coinsSvcFeeSettings.menu = {}
  },
  [COINS_SVC_SAVE_LOADING](state) {
    state.policy.polCoinsSvcFee.init = 0
    state.policy.polCoinsSvcFee.saving = true
    state.policy.polCoinsSvcFee.saveError.fieldMessages = []
    state.policy.polCoinsSvcFee.saveError.messages = []
  },
  [COINS_SVC_SAVE_SUCCESS](state) {
    state.policy.polCoinsSvcFee.init = 1
    state.policy.polCoinsSvcFee.saving = false
    state.policy.polCoinsSvcFee.saveError.fieldMessages = []
    state.policy.polCoinsSvcFee.saveError.messages = []
  },
  [COINS_SVC_SAVE_FAIL](state, errMsgs) {
    state.policy.polCoinsSvcFee.init = 2
    state.policy.polCoinsSvcFee.saving = false
    state.policy.polCoinsSvcFee.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polCoinsSvcFee.saveError.messages = errMsgs.messages
  }
}
